import React, { useState, useEffect } from "react";
import { Box, Button, Select, MenuItem } from "@mui/material";
import { Route, Routes } from 'react-router-dom'
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import { setUserInfo } from "../../redux/slice/user";
import api from "../../API";
import GroupIcon from '@mui/icons-material/Group';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import RuleIcon from '@mui/icons-material/Rule';
import TranslateIcon from '@mui/icons-material/Translate';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { SearchBackDrop } from "../component/common/SearchBackDrop";

interface UseCheckCntType {
  t_cnt: number;
  c_cnt: number;
  f_cnt: number;
}

const initailData_use_check: UseCheckCntType = {
  t_cnt: 0,
  c_cnt: 0,
  f_cnt: 0
};

const EvalWorkerPage = (props:any) => {

  const dispatch = useDispatch();

  const nav = useNavigate();

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let evkn_role = auth.user.roles.some((obj:any) => ['EVAL','EVAL_PRC'].includes(obj.role));

  let evlt_role = auth.user.roles.some((obj:any) => ['EVLT_PRC'].includes(obj.role));

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
 
  const getAuth = async () => {
    if(!email){ nav('/') }
    api.get('/@me',{params:{email:email}})
    .then((resp:any) => {dispatch(setUserInfo(resp.data)); console.log('/@me',resp.data) })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }


  useEffect(() => {
    getAuth()
  },[])

  return (
    <Box>
      <Box sx={{ backgroundColor: "#fff", height: "100%", maxWidth: "100%" }}>
        {/* <Box sx={{textAlign: "center", paddingTop:"20px"}}><img style={{width:"120px", marginLeft:"8px", objectFit: "cover", alignSelf: "center"}} src={process.env.PUBLIC_URL + '/img/sw_flag.jpg'} /></Box> */}
        <Box sx={{fontSize:"60px", textAlign: "center", padding: "5px 20px 20px 20px"}}>성능평가 데이터</Box>
        {/* <Box sx={{display:"flex", justifyContent: "center", marginTop:"100px"}}> */}
        <Box>
          <Box sx={{display:"flex", justifyContent: "center", marginTop:"100px"}}>
          {["EVAL001", "EVAL002","EVAL003","EVAL004","EVAL006","EVAL007","EVAL022","EVAL023","EVAL024"].includes(worker) &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#555fb6", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('evkn-category')}>
              지식-카테고리 검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b65586", color: "#fff", "&:hover": { background: "#da51da",color: "#fff"}}} variant="contained" onClick={()=> nav('rsimpleqa')}>
              RSimpleQA 최종검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b6b455", color: "#fff", "&:hover": { background: "#daa351",color: "#fff"}}} variant="contained" onClick={()=> nav('rmmlu')}>
              RMMLU 최종검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b67155", color: "#fff", "&:hover": { background: "#da6651",color: "#fff"}}} variant="contained" onClick={()=> nav('rhellaswag')}>
              RHellaSwag 최종검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#555fb6", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('simple')}>
              SimpleQA 검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#65cfaf", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('prc-openbook')}>
              OpenBook 검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"2px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {/* {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "22px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#55b65d", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('hellaswag')}>
              HellaSwag 검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evkn_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b68f55", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('mmlu')}>
              MMLU 검수
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          } */}
          {/* {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "42px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#55b665", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('create-context')}>
              문장생성(장문)
            <ModeEditIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          } */}
          </Box>
          <Box sx={{display:"flex", justifyContent: "center", marginTop:"100px"}}>
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b6a855", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('bufsPage')}>
              장문이해(부산외대)
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"8px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b6a855", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('narrativeqa')}>
              NarrativeQA (장문)
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"8px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#55a3b6", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('insertSentence')}>
              LDKP (장문)
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"8px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#ae55b6", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('lfsum')}>
              LFSUM (장문)
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"8px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#61c972", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('mrcr')}>
              MRCR (장문)
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"8px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "24px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b67455", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('logiqa')}>
              LogiQA (장문)
            <ModeEditIcon sx={{fontSize:"60px", marginLeft:"8px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          {evlt_role &&
            <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "32px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#555bb6", color: "#fff", "&:hover": { background: "#51dab8",color: "#fff"}}} variant="contained" onClick={()=> nav('idk')}>
              IDK(장문)
            <ModeEditIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
            </Button>
          }
          </Box>
          {/* <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginLeft:"24px", fontWeight: 600, backgroundColor: "#b65f72", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('inst')}>
            INST 생성
          <ModeEditIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></ModeEditIcon>
          </Button>

          <Button sx={{width: "310px", height:"300px",borderRadius:"50%", fontSize: "50px", marginRight:"px", marginLeft:"50px", fontWeight: 600, backgroundColor: "#daba51", color: "#fff", "&:hover": { background: "#51a7da",color: "#fff"}}} variant="contained" onClick={()=> nav('isp')}>
            검수 
          <FactCheckIcon sx={{fontSize:"100px", marginLeft:"10px", color:"#fff",justifyContent: "center" }}></FactCheckIcon>
          </Button> */}
        </Box>
        
      </Box>

    </Box>
  );
};

export default EvalWorkerPage;
